export const isIOSWeb = () => {
  return (
    /iPad|iPhone|iPod/.test(navigator?.userAgent) ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform))
  )
}
